import { render, staticRenderFns } from "./ApiConnectionIcon.vue?vue&type=template&id=b0c72f52&"
import script from "./ApiConnectionIcon.vue?vue&type=script&lang=js&"
export * from "./ApiConnectionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports